<template>
    <table class="compensation-chart-key">
        <tr v-for="datum in values" :key="datum.label">
            <th>{{ datum.label }}</th>
            <td class="percentage-bar">
                <div
                    :style="{
                        'margin-left': `${(1 - datum.percentage) * 100}%`,
                        width: `${datum.percentage * 100}%`,
                        'background-color': datum.color,
                    }"
                ></div>
            </td>
            <td v-if="showValues" class="compensation-value">{{ formats.currency(datum.value) }}</td>
            <td class="compensation-percent">{{ formats.percentage(datum.percentage) }}</td>
        </tr>
    </table>
</template>
<script>
import { compensationFormats } from '@/utils/format'

export default {
    props: {
        values: {
            type: Array,
            required: true,
        },
        showValues: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            formats: compensationFormats,
        }
    },
}
</script>
<style>
.compensation-chart-key {
    table-layout: fixed;
    line-height: 24px;
    white-space: nowrap;

    th {
        text-align: left;
        width: 96px;
    }

    td.compensation-value {
        text-align: right;
    }

    td.compensation-percent {
        text-align: right;
        width: 100px;
    }
}
</style>
